var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30483 1.07975C9.19336 0.935702 9.06406 0.806409 8.92002 0.694931C8.59149 0.440689 8.20972 0.336977 7.7785 0.289885C7.36381 0.244599 6.84526 0.246922 6.21079 0.249764L4.52621 0.257281C4.25007 0.258513 4.02722 0.483367 4.02845 0.759506C4.02968 1.03565 4.25454 1.2585 4.53068 1.25727L6.18544 1.24989C6.85701 1.24689 7.31844 1.24559 7.66994 1.28398C7.78417 1.29645 7.87963 1.31253 7.9607 1.33196L0.875059 8.4176C0.679797 8.61286 0.679797 8.92944 0.875059 9.12471C1.07032 9.31997 1.3869 9.31997 1.58217 9.12471L8.66781 2.03906C8.68724 2.12013 8.70332 2.2156 8.71579 2.32983C8.75417 2.68132 8.75287 3.14275 8.74988 3.81433L8.74249 5.46909C8.74126 5.74523 8.96412 5.97008 9.24026 5.97132C9.5164 5.97255 9.74125 5.74969 9.74248 5.47355L9.75 3.78897C9.75284 3.1545 9.75517 2.63595 9.70988 2.22127C9.66279 1.79005 9.55908 1.40827 9.30483 1.07975Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/arrow-up-right.337984c91768097ff63f260f0def5525.svg";
export { ForwardRef as ReactComponent };